export const NFT_STATUS = {
    ON_SALE: 'ON_SALE',
    OWNER: 'OWNER',
    CREATOR: 'CREATOR',
    FAVORITE: 'FAVORITE',
    NOT_FOR_SALE: 'NOT_FOR_SALE'
}